// removed by extract-text-webpack-plugin
module.exports = {"buttons":"Voajd_FHBbB9qvVxShpLY","buttonsImage":"_3ZNSngxZUzXZVyHu4edOOf"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/elements/Buttons/ButtonsUsage/ButtonsUsage.css
// module id = 889
// module chunks = 0